<div class="other-settings-container" *ngIf="othersSpecification">
    <div class="setting-wrapper" #section>
        <div class="setting-title">
            {{ 'system-specifications.items.title' | translate }}
        </div>
        <div>
            <ng-conatiner *ngIf="userCanEdit">
                <app-textarea-with-error
                    class="input-form"
                    [inputValue]="othersSpecification.items"
                    legend=""
                    [validatorFunction]="validatorFunction"
                    (onInputUpdated)="onItemsTextAreaChange($event)"
                    [rows]="7"
                    [placeholder]="'system-specifications.others.placeholder'"
                    [maxLength]="1000"
                    [hasCounter]="true"
                ></app-textarea-with-error>
            </ng-conatiner>
            <ng-conatiner *ngIf="!userCanEdit">
                <div class="text-readonly-container">
                    {{ othersSpecification.items }}
                </div>
            </ng-conatiner>
        </div>
    </div>
    <div class="setting-wrapper" #section>
        <div class="setting-title">
            {{ 'system-specifications.notes.title' | translate }}
        </div>
        <div>
            <ng-conatiner *ngIf="userCanEdit">
                <app-textarea-with-error
                    class="input-form"
                    [inputValue]="othersSpecification.notes"
                    legend=""
                    [validatorFunction]="validatorFunction"
                    (onInputUpdated)="onNotesTextAreaChange($event)"
                    [rows]="7"
                    [placeholder]="'system-specifications.others.placeholder'"
                    [maxLength]="1000"
                    [hasCounter]="true"></app-textarea-with-error>
            </ng-conatiner>
            <ng-conatiner *ngIf="!userCanEdit">
                <div class="text-readonly-container">
                    {{ othersSpecification.notes }}
                </div>
            </ng-conatiner>
        </div>
    </div>
</div>
